/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetProductFeaturesSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetProductFeaturesRequest = {
  /**
   * Organization whose product features to read.
   */
  organizationId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetProductFeaturesSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetProductFeaturesSecurity$outboundSchema: z.ZodMiniType<
  GetProductFeaturesSecurity$Outbound,
  GetProductFeaturesSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getProductFeaturesSecurityToJSON(
  getProductFeaturesSecurity: GetProductFeaturesSecurity,
): string {
  return JSON.stringify(
    GetProductFeaturesSecurity$outboundSchema.parse(getProductFeaturesSecurity),
  );
}

/** @internal */
export type GetProductFeaturesRequest$Outbound = {
  organization_id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetProductFeaturesRequest$outboundSchema: z.ZodMiniType<
  GetProductFeaturesRequest$Outbound,
  GetProductFeaturesRequest
> = z.pipe(
  z.object({
    organizationId: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      organizationId: "organization_id",
      gramSession: "Gram-Session",
    });
  }),
);

export function getProductFeaturesRequestToJSON(
  getProductFeaturesRequest: GetProductFeaturesRequest,
): string {
  return JSON.stringify(
    GetProductFeaturesRequest$outboundSchema.parse(getProductFeaturesRequest),
  );
}
